import { useEffect, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';

import deviceActions from '@state/device/actions';
import getColumnsDataInfo from './getColumnsDataInfo';

function useGroupCondition({ index }) {

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const orConditions = useSelector(({ device: a }) => a.createEditValues.conditions[index]);
  const isEditDefault = useSelector(({ device }) => device.isEditDefault);
  const columnsDataInfo = useMemo(() => getColumnsDataInfo({ t }), [t]);

  const valueType = [
    {
      name: 'AZURE_ONLINE', value: 1, description: t('form.condition_rules.AZURE_ONLINE'), label: 'INFO',
    },
    {
      name: 'AZURE_COM', value: 2, description: t('form.condition_rules.AZURE_COM'), label: 'WARNING',
    },
    {
      name: 'AZURE_ENABLE', value: 3, description: t('form.condition_rules.AZURE_ENABLE'), label: 'ERROR',
    },
    {
      name: 'SD_OK', value: 4, description: t('form.condition_rules.SD_OK'), label: 'ERROR',
    },
    {
      name: 'MODBUS_COM', value: 5, description: t('form.condition_rules.MODBUS_COM'), label: 'ERROR',
    },
    {
      name: 'UPDATED_TIME', value: 6, description: t('form.condition_rules.UPDATED_TIME'), label: 'WARNING',
    },
    {
      name: 'EXTRTC_OK', value: 7, description: t('form.condition_rules.EXTRTC_OK'), label: 'ERROR',
    },
    {
      name: 'UPDATING', value: 8, description: t('form.condition_rules.UPDATING'), label: 'INFO',
    },
    {
      name: 'UPDATE_OK', value: 9, description: t('form.condition_rules.UPDATE_OK'), label: 'ERROR',
    },
    {
      name: 'HAS_CONN_STR', value: 10, description: t('form.condition_rules.HAS_CONN_STR'), label: 'ERROR',
    },
    {
      name: 'INTERNET_CONNECTION', value: 11, description: t('form.condition_rules.INTERNET_CONNECTION'), label: 'INFO',
    },
    {
      name: 'RESET_EVENT', value: 12, description: t('form.condition_rules.RESET_EVENT'), label: 'WARNING',
    },
    {
      name: 'RESERVED', value: 13, description: t('form.condition_rules.RESERVED'), label: '',
    },
  ];

  const removeGroupCondition = useCallback(() => {

    dispatch(deviceActions.removeCreateEditValuesGroupConditions(index));
    // eslint-disable-next-line
  }, []);

  const addOrCondition = useCallback(() => {

    dispatch(deviceActions.addOrCondition(index));///
    // eslint-disable-next-line
  }, []);

  useEffect(() => {

    if (orConditions.length === 0) addOrCondition();
    // eslint-disable-next-line
  }, []);

  return {
    removeGroupCondition,
    orConditions,
    addOrCondition,
    isEditDefault,
    columnsDataInfo,
    valueType,
  };

}

export default useGroupCondition;
